module.exports = __webpack_public_path__ + "img/informacionrde.6e72bb1c.jpg";